module.exports = __webpack_public_path__ + "static/media/icon-header-logout.85c11908.svg";